'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _middleware = require('../../middleware');

var _paths = require('./paths');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

exports.default = function (feis_id, stage_id) {
  return function (dispatch, getState) {
    var events = (0, _paths.getEventsOnStage)(getState(), stage_id, getState()) || (0, _immutable.List)();

    return dispatch(_defineProperty({
      feis_id: feis_id,
      stage_id: stage_id,
      events: events

    }, _middleware.CALL_API, {
      config: {
        url: (0, _paths.feisStagesPrefix)(feis_id) + '/' + stage_id,
        method: 'DELETE'
      },
      types: ['DELETE_STAGE_START', 'DELETE_STAGE', 'DELETE_STAGE_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/stages/deleteStage.js
// module id = 680
// module chunks = 0